// app/router.options.ts
import type { RouterConfig } from '@nuxt/schema'
// 不再直接导入 router.inapp 和 router.client
// 而是从一个统一的别名路径导入，例如 '#build/custom-routes'
import customRoutes from '#custom-routes'

export default <RouterConfig>{
  routes: () => {
    // 这里不需要再判断环境了，因为 customRoutes 已经由 alias 指向了正确的文件
    return customRoutes
  }
}
